import { render } from "./RegisterRoute.vue?vue&type=template&id=628dbd00"
import script from "./RegisterRoute.vue?vue&type=script&lang=js"
export * from "./RegisterRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__